/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Next_TitleInputs */

const en_directory_promotion_next_title = /** @type {(inputs: Directory_Promotion_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const zh_directory_promotion_next_title = /** @type {(inputs: Directory_Promotion_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Directory_Promotion_Next_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_next_title = /** @type {((inputs?: Directory_Promotion_Next_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Next_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_next_title(inputs)
	return zh_directory_promotion_next_title(inputs)
});
export { directory_promotion_next_title as "directory.promotion.next_title" }